import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import { Typography, useMediaQuery } from '@mui/material';

import AssetService from '../../../../shared/services/AssetService';
import React from 'react';
import Timeline from '@mui/lab/Timeline';
import { TimelineAsset } from '../../../models/LessonComponentContent';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { TimelineProps } from './Timeline';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import styles from '../../../styles/Timeline.module.scss';
import useThemes from '../../../../shared/hooks/useThemes';

interface ItemDisplayProps {
  item: TimelineAsset;
}

export default function TimelineView(props: TimelineProps) {
  const items = props.component?.content?.timeline || [];
  const lineColor = props.component?.settings?.primaryColor;
  const isMobile = useMediaQuery('(max-width: 600px)');

  const ItemDisplay = (props: ItemDisplayProps) => {
    const { dateAndTime, heading, paragraph, itemColor, itemBorder, itemIcon } =
      props.item;

    const src = AssetService.getAssetUrl(itemIcon);
    const { muiTheme } = useThemes();
    //Get subheading font
    const headingFontsize = muiTheme.typography.h5.fontSize;
    const headingFontfamily = muiTheme.typography.h5.fontFamily;

    return (
      <TimelineItem>
        <TimelineSeparator>
          {src ? (
            <TimelineDot
              sx={{
                backgroundColor: 'unset',
                boxShadow: 'unset',
                margin: 'unset',
                borderColor: itemBorder
              }}
            >
              <img className={styles.iconView} src={src} />
            </TimelineDot>
          ) : (
            <TimelineDot
              sx={{
                backgroundColor: itemColor,
                borderColor: itemBorder,
                margin: '11.5px'
              }}
            />
          )}
          <TimelineConnector sx={{ backgroundColor: lineColor }} />
        </TimelineSeparator>
        <TimelineContent className="itemTimeline">
          <Typography className={styles.typographyFont}>
            <span
              className="ql-editor"
              dangerouslySetInnerHTML={{
                __html: dateAndTime
              }}
            ></span>
          </Typography>
          <Typography
            sx={{ fontFamily: headingFontfamily, fontSize: headingFontsize }}
          >
            <span
              className="ql-editor"
              dangerouslySetInnerHTML={{
                __html: heading
              }}
            ></span>
          </Typography>
          <Typography className="style-p">
            <span
              className="ql-editor"
              dangerouslySetInnerHTML={{
                __html: paragraph
              }}
            ></span>
          </Typography>
        </TimelineContent>
      </TimelineItem>
    );
  };

  return (
    <Timeline
      position={isMobile ? 'right' : 'alternate-reverse'}
      sx={
        isMobile && {
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0
          }
        }
      }
    >
      {items.map((item, index) => (
        <ItemDisplay key={index} item={item} />
      ))}
    </Timeline>
  );
}
